import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import React, { Suspense } from "react";
import { Toaster } from "~/components/ui/sonner";
import type { RootRouteContext } from "~/types";

const TanStackRouterDevtools =
	process.env.NODE_ENV === "production"
		? () => null // Render nothing in production
		: React.lazy(() =>
				// Lazy load in development
				import("@tanstack/react-router-devtools").then((res) => ({
					default: res.TanStackRouterDevtools,
				})),
			);

export const Route = createRootRouteWithContext<RootRouteContext>()({
	component: () => (
		<>
			<Outlet />
			<Toaster richColors />
			<Suspense>
				<TanStackRouterDevtools position="bottom-left" />
				<ReactQueryDevtools initialIsOpen={false} position="left" />
			</Suspense>
		</>
	),
});
